import { Banknote, Coins, CreditCard, QrCode } from "lucide-react";
import React from "react";

const dinheiro = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

const FORMAS = [
  { id: "pix", rotulo: "PIX", icone: QrCode },
  { id: "dinheiro", rotulo: "Dinheiro", icone: Banknote },
  { id: "cartao", rotulo: "Cartão", icone: CreditCard },
];

// Segundo passo: a forma. PIX online gera o QR aqui mesmo; dinheiro e cartão
// (e o PIX, se a loja não tem PIX online) vão pro caixa. O saldo de cashback
// da pessoa pode abater do PIX — igual ao Totem.
export default function PagarForma({ forma, onForma, valor, elegivel, cashback, usarCashback, onUsarCashback, pixOnline, darkMode }) {
  const cartao = darkMode ? "bg-zinc-900 border-zinc-800" : "bg-zinc-50 border-zinc-200";
  const saldo = Number(cashback?.saldo || 0);
  // Mesma conta do servidor: carteira só sobre produto fora de promoção
  const podeUsar = Math.min(saldo, valor, elegivel ?? valor);
  const usado = usarCashback ? podeUsar : 0;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-2">
        {FORMAS.map(({ id, rotulo, icone: Icone }) => (
          <button key={id} type="button" onClick={() => onForma(id)} data-e2e={`forma-${id}`}
            className={`h-20 rounded-2xl border-2 flex flex-col items-center justify-center gap-1 font-bold transition ${cartao} ${forma === id ? "border-primary ring-2 ring-primary/30" : ""}`}>
            <Icone className="w-6 h-6 text-primary" />
            <span className="text-sm">{rotulo}</span>
          </button>
        ))}
      </div>
      {forma === "pix" && pixOnline && cashback?.habilitado && podeUsar > 0 ? (
        <button type="button" onClick={() => onUsarCashback(!usarCashback)} data-e2e="usar-cashback"
          className={`w-full rounded-2xl border-2 px-4 py-3 flex items-center gap-3 text-left ${cartao} ${usarCashback ? "border-emerald-500" : ""}`}>
          <Coins className="w-5 h-5 text-emerald-500 shrink-0" />
          <span className="flex-1">
            <span className="block font-bold text-sm">Usar {dinheiro(podeUsar)} da carteira</span>
            <span className="block text-xs opacity-60">Saldo de cashback: {dinheiro(saldo)}</span>
          </span>
          <span className={`w-11 h-6 rounded-full relative transition ${usarCashback ? "bg-emerald-500" : "bg-zinc-400/50"}`}>
            <span className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${usarCashback ? "left-6" : "left-1"}`} />
          </span>
        </button>
      ) : null}
      {forma === "pix" && pixOnline ? (
        <div className="flex items-center justify-between text-sm">
          <span className="opacity-70">{usado > 0 ? "PIX (depois da carteira)" : "Total no PIX"}</span>
          <span className="text-xl font-black tabular-nums" data-e2e="pagar-valor-pix">{dinheiro(Math.max(0, valor - usado))}</span>
        </div>
      ) : null}
    </div>
  );
}
